module.exports = __webpack_public_path__ + "70271b02e0bff6944ae5e55fd59fbce1.png";